
import ChangePassword from "./pages/Auth/ChangePassword";
import BankTransfer from "./pages/BankTransfer";
import Dashboard from "./pages/Dashboard"
import MasterCardPaymentSucceefull from "./pages/MasterCardPaymentSucceefull";
import MasterCardPaymentFailed from "./pages/MasterCardPaymentFailed";
import MyTransaction from "./pages/MyTransaction";
import PageNotFound from "./pages/PageNotFound";
import PayFortReturn from "./pages/PayFortReturn";
import PaymentStatus from "./pages/PaymentStatus";
import PsychometricTest from "./pages/PsychometricTest";
import Referal from "./pages/Referal";
import StudentBankDetail from "./pages/StudentBankDetail";
import StudyMaterialMasterCardSuccess from "./pages/StudyMaterialMasterCardSuccess";
import UpayPaymentSuccessful from "./pages/UpayPaymentSucceefull";
import VanSubscription from "./pages/VanSubscription";

const routes = [
    {
        name: "Dashboard",
        layout: "/student",
        path: "dashboard",
        component: <Dashboard />,
    },
    {
        name: "Bank Transfer",
        layout: "/student",
        path: "bank-transfer/:userId/:payType/:installmentId",
        component: <BankTransfer />,
    },
    {
        name: "Bank Transfer",
        layout: "/student",
        path: "my-transactions",
        component: <MyTransaction />,
    },
    {
        name: "Student Referal",
        layout: "/student",
        path: "student-referal",
        component: <Referal />,
    },
    {
        name: "Student Bank Detail",
        layout: "/student",
        path: "student-bank-detail/:id",
        component: <StudentBankDetail />,
    },
    
    {
        name: "Payfort",
        layout: "/student",
        path: "paymentstatus/:status",
        component: <PayFortReturn />,
    },
    {
        name: "Payment Status",
        layout: "/student",
        path: "checkpaymentstatus/:status",
        component: <PaymentStatus />,
    },
    {
        name: "Psychometric Test",
        layout: "/student",
        path: "psychometric-test",
        component: <PsychometricTest />,
    },
    {
        name: "Payment Successfull",
        layout: "/student",
        path: "payment-successfull/:userId/:payType/:installmentNumber",
        component: <MasterCardPaymentSucceefull />,
    },
    {
        name: "Payment Failed",
        layout: "/student",
        path: "payment-failed/:userId/:payType/:installmentNumber",
        component: <MasterCardPaymentFailed />,
    },
    {
        name: "Study Material Payment Successfull",
        layout: "/student",
        path: "studymaterial-payment-successfull",
        component: <StudyMaterialMasterCardSuccess />,
    },
    {
        name: "Payment Successfull",
        layout: "/student",
        path: "upay-payment-successfull/:userId/:payType/:installmentNumber",
        component: <UpayPaymentSuccessful />,
    },
    {
        name: "Change Password",
        layout: "/student",
        path: "change-password/:id",
        component: <ChangePassword />,
    },
    {
        name: "Van Subscription",
        layout: "/student",
        path: "van-subscription/:id",
        component: <VanSubscription />,
    },
    {
        name: "Page Not Found",
        layout: "/student",
        path: "*",
        component: <PageNotFound />,
    },
    
]

export default routes;